import axios from '../../../utils/customAxiosUtil';

import qs from 'qs';
import { AccountFormData, AccountState } from '../models/accountModel';
import { DefaultSeachModel } from '../../../models/ComnModel';
import { ACCOUNT } from '../../../../configs/constants';
// import { ReponseControlGpHistory } from '../models/controlGpModel';

export const accountApi = {
  register: async (data: AccountFormData) => {
    const param = {
      ...data.data,
      ...ACCOUNT,
      terms: data.agreeTerms
    };
    const res = await axios.post('api/acnt/cstmr/register', param);
    return res;
  },

  temrsList: async (param: DefaultSeachModel) => {
    const queryString = qs.stringify(param, {
      addQueryPrefix: true,
      arrayFormat: 'repeat'
    });
    return await axios.get(`api/acnt/terms/list` + queryString);
  },
  crtfyhp: async (hpno: string) => {
    return await axios.get(`api/acnt/crtfyhp/register/send?hpno=${hpno}`);
    ``;
  },
  crtfyhpConfirm: async (hpno: string, crtfyNo: string) => {
    return await axios.get(
      `api/acnt/crtfyhp/register/confirm?hpno=${hpno}&crtfyNo=${crtfyNo}`
    );
  }

  // list: async (data: string) => {
  //   const queryString = qs.stringify(data, {
  //     addQueryPrefix: true,
  //     arrayFormat: 'repeat'
  //   });

  //   return await axios.get(`/api/anls/hstry/list` + queryString);
  // },
  // detail: async (id: string) => {
  //   return await axios.get(`/api/anls/hstry/detail/${id}`);
  // },

  // log: async (id: string) => {
  //   return await axios.get(`/api/anls/hstry/log/${id}`);
  // }
  // getHistory: async (id: string) => {
  //   if (!id) {

  //     return null;
  //   }
  //   const { data }: ReponseControlGpHistory = await axios.get(
  //     `api/ctr/cntrl/history/${id}`
  //   );
  //   return data;
  // }
};
